// Internal modules
import { logger } from '@/lib/logger';
import { redirectToGenericError } from '@/lib/utils/redirects';
import {
  isIframe,
  isIncontext,
  isLegacyIncontext,
  isPopup,
} from '@/lib/utils/incontext';

const checkFrameBust = (): void => {
  // @ts-expect-error (paypal is not typed on window right now)
  if (isIframe() && !window?.paypal?.allowIframe?.()) {
    logger.info('frame_bust_disallowed_iframe');

    try {
      // We want to allow this so that when window.top is null,
      // it will go in the catch statement.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      window.top!.location = window.location.href;
    } catch (err: any) {
      logger.error('frame_bust_failed', err);
    }

    setTimeout(() => {
      logger.error('frame_bust_did_not_redirect_after_2s');
      redirectToGenericError();
    }, 2000);
  }
};

const logIncontext = (): void => {
  if (isIncontext()) {
    logger.info('incontext_integration', {
      isLegacyIntegration: isLegacyIncontext(),
      type: isPopup() ? 'popup' : 'iframe',
      xprops: Boolean(window.xprops),
    });
  }
};

export { checkFrameBust, logIncontext };
